import DataService from './DataService'
export default {
  fetchBillingHistoryData() {
    return DataService.get(
      process.env.VUE_APP_API_BASE_URL + '/get_billing_history'
    )
  }
}
